<template>
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            v-model="date"
            :label="label"
            :prepend-inner-icon="icon"
            readonly
            v-bind="attrs"
            v-on="on"
            clearable
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          no-title
          scrollable
          @change="textFieldChanged"
        ></v-date-picker>
    </v-menu>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: "DatePicker",
    data() {
      return {
        menu: false
      }
    },
    props: {
      value: { type: Date },
      label: { type: String },
      icon: { type: String, default: 'mdi-calendar' },
    },
    computed: {
      date: {
        get() {
          const isValidDate = this.value && dayjs(this.value).isValid()
          return isValidDate ? dayjs(this.value).format('YYYY-MM-DD') : null
        },
        set(value) {
          this.$emit('input', dayjs(value).toDate())
        }
      }
    },
    methods: {
      textFieldChanged(date) {
        this.$refs.menu.save(date)
      }
    }
  }
</script>